import tw from "twin.macro";

export const Wrapper = tw.div`
  mt-8
  space-y-8
`;
